'use client';

import './home-dashboard.scss';

export const HomeDashboard = () => {
  return (
    <div className="HomeDashboard">
      <div className="HomeDashboard__content">
        {/* Primary column — "Just for You" */}
        <section className="HomeDashboard__primary flex flex-col gap-comfy-sm">
          <h2 className="text-heading-sm font-bold">Just for You</h2>
          <p className="text-body-sm text-neutral-600">
            Meaningful ways to stay connected.
          </p>
          {/* Child content (sponsorship cards, gift CTAs) composed here as ready */}
        </section>
      </div>

      {/* Sidebar — desktop: right column; mobile: inline below primary */}
      <aside className="HomeDashboard__sidebar">
        <h1>Upcoming Events</h1>
      </aside>
    </div>
  );
};
